import { css } from '@emotion/react';
import React from 'react';
import { DropdownStyle } from 'styles/DropdownStyle';

export const Dropdown = ({ children, isOpen }: { children: any; isOpen?: boolean }) => {
	return (
		<div
			css={[
				DropdownStyle(),
				css`
					position: absolute;
					top: 100%;
					z-index: 10;
					min-width: 100%;

					${!isOpen &&
					css`
						display: none;
					`}
				`,
			]}
		>
			{children}
		</div>
	);
};
